var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsRoomImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9006 17H18.0906C18.4835 17.0507 18.8827 17.0105 19.2576 16.8827C19.6326 16.7549 19.9732 16.5428 20.2533 16.2627C20.5334 15.9826 20.7455 15.642 20.8733 15.267C21.0011 14.8921 21.0413 14.4929 20.9906 14.1V2H2.9906V14.1C2.94165 14.4934 2.98331 14.8928 3.1124 15.2676C3.24149 15.6425 3.45459 15.9828 3.73539 16.2627C4.0162 16.5425 4.35728 16.7544 4.73256 16.8822C5.10783 17.01 5.50736 17.0503 5.9006 17V17Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H22",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22L12 20V17",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22L12 20",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11L10.65 8.37C10.7043 8.32056 10.7692 8.28419 10.8397 8.26365C10.9102 8.24311 10.9845 8.23895 11.0568 8.2515C11.1292 8.26404 11.1977 8.29295 11.2572 8.33601C11.3167 8.37908 11.3655 8.43517 11.4 8.5L12.6 10.5C12.6353 10.564 12.6846 10.6192 12.7441 10.6615C12.8036 10.7039 12.8718 10.7324 12.9438 10.7449C13.0158 10.7574 13.0897 10.7535 13.16 10.7336C13.2303 10.7137 13.2952 10.6783 13.35 10.63L16.5 8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsRoomImg);
export default __webpack_public_path__ + "static/media/NewsRoomImg.2fca02f5857e26f240694afb7b3debe6.svg";
export { ForwardRef as ReactComponent };